/**
 * Session cleanup utility
 * Helps prevent stale session data from causing navigation issues
 */

/**
 * Cleans up potentially stale session data
 * Should be called during app initialization
 */
export function cleanupStaleSessionData() {
  try {
    // Only clear MSAL interaction status if it's been stuck for too long
    const hasMsalError = sessionStorage.getItem("msal.error");
    
    // Only clear if there's an actual error or if interaction has been stuck
    if (hasMsalError) {
      console.log('[Session Cleanup] Detected MSAL error, clearing...');
      sessionStorage.removeItem("msal.error");
      sessionStorage.removeItem("msal.error.description");
    }
    
    // Don't clear interaction status unless there's an error
    // This prevents clearing valid authentication flows
    
    // Check if we have encryption data but no user accounts
    const hasEncryptionData = sessionStorage.getItem('encryptionDerivedKey') || 
                              sessionStorage.getItem('encryptionInitialized');
    
    if (hasEncryptionData) {
      // We'll let the router handle encryption restoration
      // Just log that we found encryption data
      console.log('[Session Cleanup] Found encryption data in session');
    }
    
    console.log('[Session Cleanup] Session cleanup completed');
  } catch (error) {
    console.error('[Session Cleanup] Error during cleanup:', error);
  }
}

/**
 * Clears all session data related to authentication and encryption
 * Should be called during logout
 */
export function clearAllSessionData() {
  try {
    // Clear MSAL-related data
    sessionStorage.removeItem("msal.interaction.status");
    sessionStorage.removeItem("msal.error");
    sessionStorage.removeItem("msal.error.description");
    
    // Clear encryption-related data
    sessionStorage.removeItem('encryptionDerivedKey');
    sessionStorage.removeItem('encryptionInitialized');
    sessionStorage.removeItem('needsNewEncryption');
    sessionStorage.removeItem('redirectAfterUnlock');
    
    console.log('[Session Cleanup] All session data cleared');
  } catch (error) {
    console.error('[Session Cleanup] Error clearing session data:', error);
  }
} 